import {
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter, forwardRef,
  inject,
  Input,
  NgZone,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { ToolBarToolComponent } from '@progress/kendo-angular-toolbar';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { IconComponent } from '../../../../../../../../shared/components/ui/icon/icon.component';
import { PopupModule } from '@progress/kendo-angular-popup';
import { SliderModule } from '@progress/kendo-angular-inputs';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '../../../../../../../../shared/pipes/translate/translate.pipe';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DocumentEventsService } from 'src/app/shared/services/document-events/document-events.service';

export enum CustomCanvasActions{
  RevertImage = 1,
  RemoveStrokes = 2,
  RemoveImage = 3,
  RemoveAll = 4
}
@Component({
  selector: 'bizz-custom-canvas-actions',
  standalone: true,
  imports: [
    ButtonModule,
    IconComponent,
    PopupModule,
    SliderModule,
    NgClass,
    TranslatePipe
  ],
  templateUrl: './custom-canvas-actions.component.html',
  styleUrl: './custom-canvas-actions.component.scss',
  providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => CustomCanvasActionsComponent) }]
})
export class CustomCanvasActionsComponent  extends ToolBarToolComponent {
  @ViewChild('toolbarTemplate', { static: true }) public override toolbarTemplate: TemplateRef<any>;
  @ViewChild('popupTemplate', { static: true }) public override popupTemplate: TemplateRef<any>;
  @Output() public valueChange = new EventEmitter<number>();
  @Input({required: true}) public actions: Array<CustomCanvasActions>;

  protected readonly CustomCanvasActions = CustomCanvasActions;

  private documentEventsService = inject(DocumentEventsService);
  private ngZone: NgZone = inject(NgZone);
  private destroyRef: DestroyRef = inject(DestroyRef);

  @ViewChild("anchor", { read: ElementRef }) public anchor: ElementRef;
  @ViewChild("popup", { read: ElementRef }) public popup: ElementRef;

  @Output() public revertImage = new EventEmitter<void>();
  @Output() public removeStrokes = new EventEmitter<void>();
  @Output() public removeImage = new EventEmitter<void>();
  @Output() public removeAll = new EventEmitter<void>()
  public constructor() {
    super();
    this.documentEventsService.documentClickEvent.
        pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(
            (event: Event) => {
                if(event?.target && this.checkHandleClick(event.target)) {
                    this.ngZone.run(() => { this.onDocumentClick(event) });
                }
        });
  }

  private checkHandleClick(target: EventTarget): boolean {
    return this.popup && !this.popup.nativeElement.contains(target) && !this.anchor.nativeElement.contains(target);
  }

  public onDocumentClick(event: Event): void {
    this.show = false;
  }

  public containsAction(action: CustomCanvasActions): boolean {
    return this.actions.includes(action);
  }
  public show = false;
  
  public onToggle(value?: boolean): void {
    this.show = value ? value : !this.show;
   }
}
